/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_MISSING_FROM_PLANOGRAMS_STATS = gql`
  query GetMissingFromPlanogramsStats(
    $storeId: ID!
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    missingFromPlanogramsStats(
      storeId: $storeId
      startDate: $startDate
      endDate: $endDate
    ) {
      revenue
      profit
      products {
        upc
        name
        revenue
        imageUrl
      }
    }
  }
`
